var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "checkout-summary" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showSummary,
            expression: "showSummary"
          }
        ],
        staticClass: "checkout-summary__container"
      },
      [
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c(
            "button",
            {
              staticClass:
                "checkout-summary__toggle checkout-summary__toggle--open",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleSummary($event)
                }
              }
            },
            [
              _c("span", { staticClass: "screen-reader-text" }, [
                _vm._v("Sulje yhteenveto")
              ])
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "checkout-summary__heading" }, [
            _vm._v("\n        Tuotteet\n        "),
            _c(
              "a",
              {
                staticClass: "checkout-summary__link",
                attrs: { href: "#tilaus" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.items == 0
                      ? _vm.$modeoL10n.browse_products
                      : _vm.$modeoL10n.edit
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-summary__text",
              class: { "checkout-summary__text--disabled": _vm.items == 0 }
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v("\n          Tuotteet yhteensä "),
                _c("span", { staticClass: "checkout-summary__label-detail" }, [
                  _vm._v("(" + _vm._s(_vm.items) + ")")
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "checkout-summary__value checkout-summary__value--price"
                },
                [
                  _c("price", {
                    attrs: {
                      "price-without-tax": _vm.subTotalWithoutTax,
                      "price-with-tax": _vm.subTotalWithTax
                    }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c("p", { staticClass: "checkout-summary__heading" }, [
            _vm._v("\n        Asiakas\n        "),
            _c(
              "a",
              {
                staticClass: "checkout-summary__link",
                attrs: { href: "#yhteystiedot" }
              },
              [_vm._v(_vm._s(_vm.customer ? "Vaihda" : _vm.$modeoL10n.select))]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-summary__text",
              class: { "checkout-summary__text--disabled": !_vm.customer }
            },
            [
              _vm.customer
                ? _c(
                    "p",
                    [
                      _vm.customer.billing.company
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.customer.billing.company)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.company_id
                        ? [
                            _vm._v(
                              "\n            " + _vm._s(_vm.customer.company_id)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.billing.first_name ||
                      _vm.customer.billing.last_name
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.customer.billing.first_name) +
                                " " +
                                _vm._s(_vm.customer.billing.last_name)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.order_reference
                        ? [
                            _vm._v(
                              "\n            Tilausviite: " +
                                _vm._s(_vm.customer.order_reference)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.billing.email
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.customer.billing.email)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customer.billing.phone
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.customer.billing.phone)
                            ),
                            _c("br")
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _c("p", [
                    _vm._v("\n          Asiakasta ei valittu\n        ")
                  ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "checkout-summary__section" },
          [
            _c("p", { staticClass: "checkout-summary__heading" }, [
              _vm._v("\n        Tarjouksen tiedot\n        "),
              _c(
                "a",
                {
                  staticClass: "checkout-summary__link",
                  attrs: { href: "#tarjouksen-tiedot" }
                },
                [_vm._v(_vm._s(_vm.isOfferDetailsEmpty ? "Täytä" : "Muokkaa"))]
              )
            ]),
            _vm._v(" "),
            !_vm.isOfferDetailsEmpty
              ? [
                  _c("div", { staticClass: "checkout-summary__text" }, [
                    _vm._v(
                      "\n          Tarjous WC-" +
                        _vm._s(_vm.offerdetails.id) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.offerdetails.customer_reference
                    ? _c("div", { staticClass: "checkout-summary__text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.offerdetails.customer_reference) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_date
                    ? _c("div", { staticClass: "checkout-summary__text" }, [
                        _c("p", { staticClass: "checkout-summary__label" }, [
                          _vm._v("\n            Jättöpäivä\n          ")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "checkout-summary__value" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.offerdetails.offer_date) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_expiry
                    ? _c("div", { staticClass: "checkout-summary__text" }, [
                        _c("p", { staticClass: "checkout-summary__label" }, [
                          _vm._v("\n            Voimassaoloaika\n          ")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "checkout-summary__value" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.offerdetails.offer_expiry) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.status
                    ? _c("div", { staticClass: "checkout-summary__text" }, [
                        _c("p", { staticClass: "checkout-summary__label" }, [
                          _vm._v("\n            Tarjouksen tila\n          ")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "checkout-summary__value" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.statusLabels[_vm.offerdetails.status]
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_delivery
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Kuljetus\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_delivery) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_installation
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Asennus\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_installation) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_recycling
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Kierrätys\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_recycling) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_delivery_time
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Toimitusaika\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_delivery_time) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_terms
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Toimitusehto\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_terms) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_payment_terms
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Maksuehto\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_payment_terms) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerdetails.offer_guarantee
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-summary__text checkout-summary__text--highscreen"
                        },
                        [
                          _c("p", { staticClass: "checkout-summary__label" }, [
                            _vm._v("\n            Takuu\n          ")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "checkout-summary__value" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.offerdetails.offer_guarantee) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isOfferDetailsEmpty
              ? _c(
                  "p",
                  {
                    staticClass:
                      "checkout-summary__text checkout-summary__text--disabled"
                  },
                  [_vm._v("\n        Tarjouksen tietoja ei syötetty\n      ")]
                )
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "checkout-summary__section" }, [
          _c("div", { staticClass: "checkout-summary__text" }, [
            _c("p", { staticClass: "checkout-summary__label" }, [
              _vm._v("\n          Välisumma\n        ")
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "checkout-summary__value checkout-summary__value--price"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("formatPrice")(_vm.subTotalWithoutTax)) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout-summary__text" }, [
            _c("p", { staticClass: "checkout-summary__label" }, [
              _vm._v("\n          " + _vm._s(_vm.$modeoL10n.vat) + "\n        ")
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "checkout-summary__value checkout-summary__value--price"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("formatPrice")(_vm.totalTax)) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "checkout-summary__total checkout-summary__total--offer"
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v("\n          Kokonaiskate\n        ")
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "checkout-summary__total__value checkout-summary__value"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("formatPercent")(_vm.profit)) +
                      " %\n        "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "checkout-summary__total checkout-summary__total--offer"
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v("\n          Yhteensä\n        ")
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "checkout-summary__total__value checkout-summary__value checkout-summary__value--price"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("formatPrice")(_vm.totalPrice)) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    !_vm.showSummary
      ? _c("div", { staticClass: "checkout-summary__mobile-preview" }, [
          _c(
            "button",
            {
              staticClass: "checkout-summary__toggle",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleSummary($event)
                }
              }
            },
            [
              _c("span", { staticClass: "screen-reader-text" }, [
                _vm._v("Näytä yhteenveto")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "checkout-summary__total checkout-summary__total--mobile"
            },
            [
              _c("p", { staticClass: "checkout-summary__label" }, [
                _vm._v("\n        Yhteensä\n      ")
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "checkout-summary__total__value checkout-summary__value checkout-summary__value--price"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatPrice")(_vm.totalPrice)) +
                      "\n      "
                  )
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f3d40f", { render: render, staticRenderFns: staticRenderFns })
  }
}